module.exports = __webpack_public_path__ + "static/media/ast.82c5086f.svg";